<template>
	<BaseCatalogCategory v-slot="{item: category, contentType}" :seo="true">
		<BaseCatalogProducts v-slot="{items: products, loading, pagination, nextPage, loadMore}" :infinite-scroll="200" @loadProducts="onLoad">
			<Body :class="['catalog-layout-page', contentType == 'manufacturer' && 'page-brand', contentType == 'search' && 'page-search', toggleFilters && 'filters-active', category?.code == 'paketi' && 'page-groupp-index']" />
			<CmsIntroContainer v-if="contentType != 'search'" :page="category">
				<template #h1>
					<h1 v-if="category?.seo_h1">{{ category.seo_h1 }}<span v-if="pagination?.items?.total" class="c-total-products"> ({{pagination.items.total}})</span></h1>
				</template>
			</CmsIntroContainer>
			<div v-else class="intro-container">
				<ClientOnly>
					<div class="wider-wrapper">
						<div class="intro-container-inner">
							<div class="page-search-intro">
								<BaseSearchResults :search-modules="[{module: 'catalog'}, {module: 'publish'}, {module: 'cms'}]" v-slot="{searchTerm}">
									<SearchTitleContainer :extraterm="searchTerm" />
								</BaseSearchResults>
							</div>
						</div>
					</div>					
				</ClientOnly>				
			</div>

			<div class="catalog-layout">		
				<div class="wider-wrapper">
					<div class="c-main">
						<BaseCatalogFilters v-slot="{searchFields}">
							<div v-if="category?.code != 'paketi'" :class="['c-sidebar', toggleFilters && 'filters-active']">
								<div class="c-sidebar-title-categories" @click="toggleFilters = false"><BaseCmsLabel code="filters" /></div>
								<CatalogFilters @close-filters="toggleFilters = false;" :total-products="pagination?.items?.total || 0" :search-fields="searchFields" :category="category" :content-type="contentType" />
							</div>
							<div class="c-products">

								<div v-if="contentType == 'manufacturer'" class="brand-intro-cnt">
									<div v-if="category?.main_image" class="brand-logo">
										<BaseUiImage :data="category.main_image_thumbs?.['width160-height70']" default="/images/no-image-185.jpg" />
									</div>
									<h1 v-else-if="category?.seo_h1">{{ category.seo_h1 }}</h1>
									<div v-if="category?.content" class="brand-desc-cnt" v-html="category.content" v-interpolation></div>
								</div>

								<template v-else>
									<div v-if="category?.content" :class="['c-desc-cnt', activeDesc && 'active']">
										<div class="c-desc" v-html="category.content" v-interpolation></div>
										<div @click="activeDesc = true" class="c-desc-btn"><BaseCmsLabel code="category_description_more"/></div>
									</div>

									<CatalogCategoriesSpecial v-if="category && contentType == 'category' && mobileBreakpoint && category?.code != 'paketi'" :category="category" />
								</template>


								<div v-if="category?.code != 'paketi'" class="clear c-toolbar">
									<div v-if="pagination.items.total > 1" class="c-counter">
										<BaseCmsLabel code="found" /> <span>{{pagination.items.total}}</span> proizvod/a									 
									</div>

									<div class="c-toolbar-buttons" :class="[pagination?.items?.total == 1 && 'c-toolbar-buttons-one']">
										<BaseCatalogSpecialFilter filter="with_qty" v-if="products?.length || route.query?.with_qty" />										
										<BaseCatalogSpecialFilter filter="discount" v-if="products?.length || route.query?.discount" />
									</div>
																									
									<div :class="['m-filters-sort', products?.length <= 1 && 'm-filters-no-sort']">
										<div v-if="searchFields.length && products?.length > 0" @click="toggleFilters = !toggleFilters" :class="['m-categories', products?.length == 0 && 'm-categories-single']"><BaseCmsLabel code="filters" /></div>								
										<CatalogSort v-if="products?.length > 1" />							
									</div>
								</div>

								<div id="items_catalog_layout">
									<template v-if="products?.length">
										<div id="items_catalog" :class="['fz0 c-items', loading && 'loading']">
											<template v-if="category?.code == 'paketi'">
												<CatalogIndexEntryGroup v-for="product in products" :key="product.id" :item="product" />
											</template>
											<BaseCatalogPromo v-else v-slot="{items: promoItems}">
												<template v-for="(product, index) in products" :key="product.id">
													<CatalogIndexEntry :item="product" :order="index + 1" :promo="promoItems" />
												</template>
											</BaseCatalogPromo>
										</div>

										<ClientOnly>
											<div class="load-more-container c-load-more-container" data-products-scroll-trigger>
												<button v-if="nextPage && !loading" type="button" class="btn btn-primary btn-load-more" @click="loadMore()"><UiLoader v-if="loading" /><span><BaseCmsLabel code="load_more_catalog" /></span></button>
											</div>
										</ClientOnly>
										<BaseUiPagination class="pagination c-pagination-items" />									
									</template>
									<template v-else>
										<div v-if="contentType == 'search'" class="c-empty" v-html="labels.get('search_no_products')"></div>
										<div v-else class="c-empty" v-html="labels.get('no_products')"></div>
									</template>
								</div>							
							</div>
						</BaseCatalogFilters>
					</div>	
				</div>
			</div>
		</BaseCatalogProducts>	
	</BaseCatalogCategory>
</template>

<script setup>
	const {scrollTo, onMediaQuery, insertBefore} = useDom();
	const {mobileBreakpoint} = inject('rwd');
	const route = useRoute();
	const labels = useLabels();

	const toggleFilters = ref(false);
	const activeDesc = ref(false);

	onMediaQuery({
		query: '(max-width: 760px)',
		enter: () => {
			insertBefore('.m-filters-sort', '.c-toolbar');
		},
	});

	function onLoad(products){
		if(products?.items.length){
			sendProductImpressions(products.items, products.contentType == 'search' ? 'search' : 'category');
		}
	}
</script>